import {error} from '@sveltejs/kit';
import {post_call} from '$lib/utils.js';

export async function load({params, fetch, data}) {
    let response = await post_call({
        'endpoint': '/get-item/',
        'body': {
            'doc_type': params.doc_type,
            'doc_id': params.doc_id,
        }
    }, fetch, data);

    if (response.msg?.startsWith('Could not find item')) {
        throw error(404, 'document niet gevonden.');
    }

    return {
        doc: response,
        doc_type: params.doc_type
    };
}
